<div class="btn-group" [class.w-100]="fullWidth()" role="group">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="btn"
      [class.btn-sm]="size() === 'sm'"
      [class.btn-primary]="value() === option.value"
      [class.btn-light]="value() !== option.value"
      [attr.data-cy]="option.dataCy || null"
      (click)="select(option)"
    >
      @if (option.icon) {
        <i class="bi {{ option.icon }} me-1"></i>
      }
      {{ option.label }}
    </button>
  }
</div>
